angular.module('dnecom')
    .controller('ProductProcessMetaDetailsController', ["$scope", "ProductUploadUtils", "MediaUtils", function ProductProcessMetaDetailsController($scope, ProductUploadUtils, MediaUtils) {
        $scope.productOgImageMarkedForDelete = false;
        $scope.productGeneratedOgImageMarkedForDelete = false;
        $scope.urlUploadBtnText = 'Upload from url';

        var allowSyncOgTitle = false;
        var allowSyncOgDescription = false;

        $scope.$watch('product.ogImage', function(newValue, oldValue) {
            if (oldValue) {
                $scope.oldOgImage = oldValue;
            }
        }, true);

        $scope.$watch('product.framedOgImage', function(newValue, oldValue) {
            $scope.oldGeneratedOgImage = oldValue;
        }, true);

        $scope.$on('product.afterSave', function() {
            if ($scope.productOgImageMarkedForDelete && $scope.oldOgImage) {
                MediaUtils.scheduleDelete($scope.oldOgImage.id);
            }

            $scope.productOgImageMarkedForDelete = false;
            $scope.productGeneratedOgImageMarkedForDelete = false;

            MediaUtils.processDelete();
        });

        $scope.selectOgFrame = function(number) {
            if ($scope.product.ogImageFrame == number) {
                $scope.product.ogImageFrame = 0;
            } else {
                $scope.product.ogImageFrame = number;
            }
        };

        $scope.getFrames = function() {
            var frames = _.range(1, 7);

            if (null === $scope.product.ogImageFrame) {
                $scope.selectOgFrame(_.first(frames));
            }

            return frames;
        };

        $scope.isProductOgImageMarkedForDelete = function() {
            return $scope.productOgImageMarkedForDelete;
        };

        $scope.cancelProductOGImageDeletion = function() {
            $scope.productOgImageMarkedForDelete = false;
            $scope.product.ogImage = $scope.oldOgImage;
        };

        $scope.markProductOGImageForDelete = function() {
            $scope.productOgImageMarkedForDelete = true;
            $scope.product.ogImage = null;
        };

        $scope.isProductGeneratedOgImageMarkedForDelete = function() {
            return $scope.productGeneratedOgImageMarkedForDelete;
        };

        $scope.cancelProductGeneratedOGImageDeletion = function() {
            $scope.productGeneratedOgImageMarkedForDelete = false;
            $scope.product.framedOgImage = $scope.oldGeneratedOgImage;
        };

        $scope.markProductGeneratedOGImageForDelete = function() {
            $scope.productGeneratedOgImageMarkedForDelete = true;
            $scope.product.framedOgImage = null;
            $scope.product.ogImageFrame = 0;
        };

        var beforeImageUpload = function() {
            $scope.urlUploadBtnText = 'Uploading...';
            $scope.urlUploading = true;
        };

        var afterImageUpload = function() {
            $scope.urlUploadBtnText = 'Upload from URL';
            $scope.urlUploading = false;
        };

        $scope.uploadOgImage = function(file) {
            beforeImageUpload();

            ProductUploadUtils.upload($scope.store, file, function(media) {
                if ($scope.product.ogImage) {
                    MediaUtils.scheduleDelete($scope.product.ogImage.id);
                }
                if ($scope.product.framedOgImage) {
                    MediaUtils.scheduleDelete($scope.product.framedOgImage.id);
                }
                $scope.product.ogImage = media;
                $scope.product.framedOgImage = null;
            }).finally(afterImageUpload);
        };

        $scope.uploadOgImageFromUrl = function(url) {
            beforeImageUpload();

            ProductUploadUtils.uploadUrl($scope.store, url, function(media) {
                if ($scope.product.ogImage) {
                    MediaUtils.scheduleDelete($scope.product.ogImage.id);
                }
                if ($scope.product.framedOgImage) {
                    MediaUtils.scheduleDelete($scope.product.framedOgImage.id);
                }
                $scope.product.ogImage = media;
                $scope.product.framedOgImage = null;
            }).finally(afterImageUpload);
        };

        $scope.syncOgTitle = function() {
            if (allowSyncOgTitle) {
                $scope.product.properties.og.title = $scope.product.properties.base.title;
            }
        };

        $scope.syncOgDescription = function() {
            if (allowSyncOgDescription) {
                $scope.product.properties.og.description = $scope.product.properties.base.description;
            }
        };

        $scope.checkOgDescription = function() {
            var og = $scope.product.properties.og;
            if (_.isUndefined(og) || _.isUndefined(og.description)) {
                return;
            }
            allowSyncOgDescription = (_.isEqual(og.description, $scope.product.properties.base.description) || _.isEmpty(og.description));
        };

        $scope.checkOgTitle = function() {
            var og = $scope.product.properties.og;
            if (_.isUndefined(og) || _.isUndefined(og.title)) {
                return;
            }
            allowSyncOgTitle = (_.isEqual(og.title, $scope.product.properties.base.title) || _.isEmpty(og.title));
        };

        $scope.checkOgTitle();
        $scope.checkOgDescription();
    }]);
